import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function PaymentResult() {
  const [params] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const isCancel = location.pathname.includes("cancel");
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(isCancel ? "cancelled" : "checking");

  useEffect(() => {
    if (isCancel || !sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("success"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
      } catch {}
      if (tries++ < 8) setTimeout(poll, 2000);
      else setStatus("failed");
    };
    poll();
  }, [sessionId, isCancel]);

  const view = {
    checking: { i: <Loader2 className="w-10 h-10 animate-spin text-blue-600" />, t: "決済を確認しています…", s: "しばらくお待ちください" },
    success: { i: <CheckCircle2 className="w-12 h-12 text-green-600" />, t: "お支払いが完了しました", s: "契約が有効化されました" },
    failed: { i: <XCircle className="w-12 h-12 text-rose-600" />, t: "決済を確認できませんでした", s: "時間をおいて再度お試しください" },
    cancelled: { i: <XCircle className="w-12 h-12 text-slate-400" />, t: "決済をキャンセルしました", s: "" },
  }[status];

  return (
    <div className="flex items-center justify-center py-24">
      <div className="text-center max-w-sm" data-testid="payment-result">
        <div className="flex justify-center mb-4">{view.i}</div>
        <h1 className="text-xl font-bold text-slate-900">{view.t}</h1>
        {view.s && <p className="text-sm text-slate-500 mt-1">{view.s}</p>}
        <Button className="mt-6 bg-blue-600 hover:bg-blue-700" onClick={() => navigate("/billing")} data-testid="back-to-billing">契約・請求へ戻る</Button>
      </div>
    </div>
  );
}
